import React, { useState } from 'react';

function MultiChoosefile({ className, type = "file", id, onChange, label = "Choose file", disabled, ...props }) {
    const [fileText, setFileText] = useState('No file chosen');

    const handleChange = (e) => {
        if (e.target.files.length > 0) {
            setFileText('No file chosen'); // Or use e.target.files[0].name
        } else {
            setFileText('No file chosen');
        }

        if (onChange) onChange(e);
    };

    return (
        <div style={{ display: 'flex', 
            alignItems: 'center', 
            gap: '10px',
            border: '1px solid #ebebeb',
            borderRadius: '8px',
            padding: '0px 0px',
            backgroundColor: '#fff' }}>
            <label
                htmlFor={id}
                style={{
                    padding: '8px 10px',
                    backgroundColor: disabled ? '#ccc' : '#e9ecef',
                    color: '#212529',
                    borderRadius: '4px',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.6 : 1
                }}
            >
                {label}
            </label>
            <span style={{ color: '#212529' }}>{fileText}</span>

            <input
                className={className}
                type={type}
                id={id}
                disabled={disabled}
                onChange={handleChange}
                {...props}
                style={{ display: 'none' }}
            />
        </div>
    );
}

export default MultiChoosefile;
